module.exports = __webpack_public_path__ + "static/media/1-5-2.f84f323d.png";